import { IonImg } from "@ionic/react";
import CrossIcon from "../assets/images/cross-select-icon.png";
import CrossBlackIcon from "../assets/images/new-cross-icon.png";
import React from "react";

interface Props {
  tagListName: string;
  tag: any;
  handleSelectionData: Function;
}
const TagsName: React.FC<Props> = ({
  tagListName,
  tag,
  handleSelectionData,
}) => {
  return (
    <>
      {/* tags-multi-select diagnosis-multi-select */}
      <div
        className={`select-multi-select-wrap ${
          tagListName == "Tags" ? "tags-multi-select" : "diagnosis-multi-select"
        }`}
      >
        <div className="select-multi-options">
          <span>{tag?.name}</span>
          <IonImg
            src={tagListName == "Tags" ? CrossBlackIcon : CrossBlackIcon}
            alt="Cross icon"
            className={
              tagListName == "Tags"
                ? "tag-cross-icon cross-icon"
                : "diagnosis-cross-icon cross-icon"
            }
            onClick={() => {
              handleSelectionData(tag, tagListName);
            }}
            placeholder={undefined}
          />
        </div>
      </div>
    </>
  );
};
export default TagsName;
